import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdde0116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-evaluation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = { class: "after-evaluation-content" }
const _hoisted_4 = { class: "rate-box" }
const _hoisted_5 = { class: "rate-item" }
const _hoisted_6 = { class: "add-refund-title" }

import { reactive, ref ,onMounted } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { Toast } from 'vant';
import Header from "@/components/header/header.vue";
import BottomBtn from "./component/afterBottomBtn.vue";
import { getFilePath,getRuleUrl } from '@/hooks/index'
import afterFileRemark from "./component/afterFileRemark.vue";
import $http from '@/plugins/http';

export default /*#__PURE__*/_defineComponent({
  __name: 'afterSaleEvaluation',
  setup(__props) {

const router = useRouter()
const route = useRoute()
let teaxAreaVal = ref('')
let ruleUrl = ref('')
let rateList = ref([{
    // 店铺评分
    title: 'Store service:',
    type: 'store',
    rate: ''
}, {
    //服务评分
    title: 'Customer Service:',
    type: 'service',
    rate: ''
}, {
    //物流评分	
    title: 'Logistics Services:',
    type: 'transit',
    rate: ''
}])
let btnData = reactive([
    {
        plain: true,
        textColor: '#333333',
        bordersColor: '#999999',
        radiusSize: '6px',
        title: 'Cancel',
    },
    {
        textColor: '#E04545',
        bordersColor: '#E04545',
        radiusSize: '6px',
        title: 'Submit',
        loading:false
    },
])
let imgPathData = ref({})
const fileList = ref([]); // 编辑下，进行图片视频返显的数据
/**fileStorage数组内对象： 
 * {
 * content: '', // 上传时返回的文件拼接路径
    attach_type: 1, // 文件类型 1：图片 2：视频
    }
 */
let fileStorage:Array<any> = reactive([])
let textAreaCon = 'Detailed description and proofs will help us process faster. (Picture Size <10M, Video <1 minute)'
const goToRule = () => {
    if(ruleUrl.value){
        window.open(ruleUrl.value)
    }
}

onMounted(()=>{
    // 获取视频/图片拼接路径及格式信息
    getFilePath().then((res:any)=>{
            imgPathData.value = res
    })
    getRuleUrl().then((res: any) => {
        const { aftersale_rules }  = res.agreements
        ruleUrl.value = aftersale_rules.display ?   res.agreements.aftersale_rules.url : ''
    })
})
const handleUpload = (data: any) => {
    fileStorage.push(data)
}
const delFile=(file:any)=>{
        fileStorage=file
}

const handleBtn = async (item: any) => {
    if (item.title === "Submit") {
        btnData[1].loading = true
        // 提交评论
        let params:any = {
            attachments: fileStorage,
            scores: {
                store: '',
                service: '',
                transit: '',
            }
        }
        teaxAreaVal.value ? params.remark = teaxAreaVal.value : ''
        rateList.value.forEach((item: any) => {
            params.scores[item.type] = item.rate ? item.rate: 5;
        })
        // let isFill = rateList.value.some((item: any) => item.rate == '') // 目前先不做星级必填
        // if (isFill) { Toast("Please score"); return }
        if(!teaxAreaVal.value.length) { 
            Toast("Please enter the  review"); 
            btnData[1].loading = false
            return
        }
        let afterId = route.params.id
        const res: any = await $http.setAfterComment(params, afterId)
        if (res.code === 200) {
            // 评论成功 前往售后全部列表
            router.push('/afterSale?name=state_all')
        }
        btnData[1].loading = false
    } else {
        // 取消返回
        router.back()
    }

}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_rate = _resolveComponent("van-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: "Service review",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: goToRule
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rateList), (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1),
            _createVNode(_component_van_rate, {
              modelValue: item.rate,
              "onUpdate:modelValue": ($event: any) => ((item.rate) = $event),
              size: "0.77rem",
              gutter: "0.69rem"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]))
        }), 256))
      ]),
      _createVNode(afterFileRemark, {
        class: "add-refund-content",
        fileList: fileList.value,
        imgPathData: _unref(imgPathData),
        teaxAreaVal: _unref(teaxAreaVal),
        "onUpdate:teaxAreaVal": _cache[0] || (_cache[0] = ($event: any) => (_isRef(teaxAreaVal) ? (teaxAreaVal).value = $event : teaxAreaVal = $event)),
        onHandleUpload: handleUpload,
        onDelFile: delFile,
        textAreaCon: _unref(textAreaCon)
      }, null, 8, ["fileList", "imgPathData", "teaxAreaVal", "textAreaCon"])
    ]),
    _createVNode(BottomBtn, {
      onClick: handleBtn,
      btnData: _unref(btnData)
    }, null, 8, ["btnData"])
  ]))
}
}

})